/**
 * Composable para configuração de exportação de gráficos ApexCharts
 */

export interface ChartExportConfig {
  filename: string
  unit?: string
}

/**
 * Retorna a configuração padrão de toolbar com exportação para gráficos
 */
export function useChartExport(config: ChartExportConfig) {
  const getToolbarConfig = () => ({
    show: true,
    tools: {
      download: true,
      selection: true,
      zoom: true,
      zoomin: true,
      zoomout: true,
      pan: true,
      reset: true,
    },
    export: {
      csv: {
        filename: config.filename,
        columnDelimiter: ',',
        headerCategory: 'Data/Hora',
        headerValue: config.unit || 'Valor',
        dateFormatter(timestamp: number) {
          const date = new Date(timestamp)
          return date.toISOString()
        },
      },
      png: {
        filename: config.filename,
      },
      svg: {
        filename: config.filename,
      },
    },
  })

  return {
    getToolbarConfig,
  }
}
